if (customElements.get('slide-show') === undefined) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();

      this.slideList = this.querySelector('[data-slide-list]');
      this.slides = this.slideList.children;
      this.slideNavs = this.querySelectorAll('[data-slide-nav]');
      this.slideSpeed = this.dataset.speed;

      if (this.slides.length <= 1) return;

      if (window.matchMedia('(pointer: coarse)').matches) {
        this.touchDevices();

      } else {
        this.currentSlide = 0;

        this.start();

        this.slideNavs.forEach((nav) =>
          nav.addEventListener('click', this.onNavClick.bind(this))
        );
      }
    }

    start() {
      this.slideAutomatically = setInterval(this.setActiveSlide.bind(this), this.slideSpeed);
      this.removeEventListener('mouseleave', this.start);
      this.addEventListener('mouseenter', this.pause);
    }

    stop() {
      clearInterval(this.slideAutomatically);
      this.removeEventListener('mouseenter', this.pause);
      this.removeEventListener('mouseleave', this.start);
    }

    pause() {
      this.stop();
      this.removeEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.start);
    }

    setActiveSlide(slide = this.currentSlide) {
      for (let slide of this.slides) slide.classList.remove('active');
      for (let nav of this.slideNavs) nav.classList.remove('active');

      if (slide === this.currentSlide) {
        this.currentSlide = (this.currentSlide != this.slides.length - 1) ? this.currentSlide + 1 : 0;
      } else {
        this.currentSlide = slide;
      }

      this.slides[this.currentSlide].classList.add('active');
      this.slideNavs[this.currentSlide].classList.add('active');
    }

    onNavClick() {
      event.preventDefault();
      this.stop();
      if (this.currentSlide == event.target.dataset.slideNav) return;
      this.setActiveSlide(event.target.dataset.slideNav);
    }

    touchDevices() {
      this.slideList.addEventListener('scroll', this.touchSlideEvent.bind(this), false);
    }

    touchSlideEvent() {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.intersectionRect.width > 0) {
            this.slideNavs.forEach((item) => item.classList.remove('active'));
            this.querySelector(`[href="#${entry.target.id}"]`).classList.add('active');
          }

          observer.unobserve(entry.target);
        })}, { rootMargin: '0px' }
      );

      for (let slide of this.slides) { observer.observe(slide) };
    }
  }

  customElements.define('slide-show', SlideShow);
}
